<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave" @row-update="handleUpdate"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain
            @click.stop="downloadExcel">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">

          <el-button type="primary" icon="el-icon-check" size="small" plain v-if="scope.row.status == 'WAIT_SEND'"
            @click.stop="handleEdit(scope.row, scope.index)">发货
          </el-button>

        </template>
        <template slot-scope="scope" slot="status">
          <el-tag v-for="obj of OrderStatus" :key="obj.value" v-if="obj.value == scope.row.status">
            {{ obj.label }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="clientType">
          <el-tag v-for="obj of clientType" :key="obj.value" v-if="obj.value == scope.row.clientType">
            {{ obj.label }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="merchantDeliveryIdForm">
          <el-select v-model="distributor" placeholder="请选择经销商" required value-key="id">
            <el-option v-for="distributor in distributors" :key="distributor.id" :label="distributor.shopName"
              :value="distributor"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="deliveryIdForm">
          <el-select v-model="company" placeholder="请选择快递公司" required value-key="id">
            <el-option v-for="company in companies" :key="company.id" :label="company.name"
              :value="company"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="promoteClientType">
          <el-tag v-for="obj of clientType" :key="obj.value" v-if="obj.value == scope.row.promoteClientType">
            {{ obj.label }}
          </el-tag>
        </template>
      </avue-crud>

    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { engineerOrderDEtailsOption } from "@/const/salesCloud/engineerOrderDEtailsOption";
import {
  findDetail,
  findCompany,
  send,
  findSendData,
  findDetailDownloadExcel,
} from "@/api/salesCloud/productOrderDetailsMerchant";

import { findByLabel, formatterTime } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "productOrderDetailsExpress",
  data() {
    return {
      tableOption: engineerOrderDEtailsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      downloadData: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      id: this.$route.query.id,
      clientType: DIC.CLIENT_TYPE,
      OrderStatus: DIC.ORDER_STATUS,
      companies: [],
      distributors: [],
      distributor: {},
      company: {},
    };
  },
  created() {
    this.handleList();
    findCompany().then((res) => {
      let data = JSON.parse(res.data);
      this.companies = data;
      console.log("data:" + JSON.stringify(data));
    });
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.isEngineer = "YES";
      this.downloadData = params;
      findDetail(this.id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.isEngineer = "YES";
      this.downloadData = params;
      findDetail(this.id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        delete params.startTime;
        delete params.endTime;
      }
      params.isEngineer = "YES";
      this.downloadData = params;
      findDetail(this.id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.isEngineer = "YES";
      this.downloadData = params;
      findDetail(this.id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row);
      if (row.deliveryType == "MERCHANT") {
        console.log(this.tableOption);
        this.deliveryType = "MERCHANT";
        this.tableOption.column[28].editVisdiplay = false;
        this.tableOption.column[29].editVisdiplay = false;
        this.tableOption.column[30].editVisdiplay = false;
        this.tableOption.column[31].editVisdiplay = true;
        this.tableOption.column[32].editVisdiplay = true;
        findSendData(row.id).then((res) => {
          let data = JSON.parse(res.data);
          console.log(data);
          let costRatio = data.costRatio;
          if (data.shopList.length == 1) {
            this.distributors = data.shopList;
            row.amount = costRatio;
            this.$refs.crud.rowEdit(row, index);



            //如果只绑定了一家经销商则直接发货

            // this.$confirm(`是否确认发货?`, "提示", {
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            //   type: "warning",
            // })
            //   .then(() => {
            //     let obj = {};
            //     obj.id = row.id;
            //     obj.deliveryId = data.shopList[0].distributorId;
            //     obj.amount = costRatio;
            //     console.log("data:" + JSON.stringify(obj));
            //     send(obj)
            //       .then((response) => {
            //         if (response.code == "200") {
            //           this.$message({
            //             showClose: true,
            //             message: "发货成功",
            //             type: "success",
            //           });
            //           this.handleList();
            //         } else {
            //           this.$message({
            //             showClose: true,
            //             message: response.message,
            //             type: "error",
            //           });
            //         }
            //       })
            //       .catch((error) => {
            //         this.loading = false;
            //         this.$message({
            //           showClose: true,
            //           message: error,
            //           type: "error",
            //         });
            //       });
            //   })
            //   .catch(() => {});
          } else {
            this.distributors = data.shopList;
            row.amount = costRatio;
            this.$refs.crud.rowEdit(row, index);
          }
          console.log(data);
        });
      } else if (row.deliveryType == "EXPRESS") {
        console.log(this.tableOption);
        this.tableOption.column[28].editVisdiplay = true;
        this.tableOption.column[29].editVisdiplay = true;
        this.tableOption.column[30].editVisdiplay = true;
        this.tableOption.column[31].editVisdiplay = false;
        this.tableOption.column[32].editVisdiplay = false;
        this.deliveryType = "EXPRESS";
        this.$refs.crud.rowEdit(row, index);
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      params.isEngineer = "YES";
      this.downloadData = params;
      findDetail(this.id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log("data:" + JSON.stringify(row));
      // this.$confirm(`是否确认发货?`, "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      // }).then(() => {
      //     let data={}
      //     data.id=this.company.id
      //     data.expressNumber=row.expressNumber
      //     data.amount=row.row
      //     send(data).then(response => {
      //         if(response.code == '200'){
      //             this.$message({
      //                 showClose: true,
      //                 message: "发货成功",
      //                 type: "success"
      //             });
      //             this.handleList();
      //         }else{
      //             this.$message({
      //                 showClose: true,
      //                 message: response.message,
      //                 type: "error"
      //             })
      //         }
      //
      //     }).catch(error => {
      //         this.loading = false
      //         this.$message({
      //             showClose: true,
      //             message: error,
      //             type: "error"
      //         })
      //     })
      // })
      //     .catch(() => { });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      this.$confirm(`是否确认发货?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {};
          data.id = row.id;
          if (this.deliveryType == "MERCHANT") {
            data.deliveryId = this.distributor.distributorId;
            data.amount = row.amount;
          }
          if (this.deliveryType == "EXPRESS") {
            data.deliveryId = this.company.id;
            data.expressNumber = row.expressNumber;
            data.amount = row.amount;
          }
          console.log("data:" + JSON.stringify(data));
          send(data)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "发货成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
      done();
    },
    downloadExcel() {
      let params = this.downloadData;
      findDetailDownloadExcel(this.id, params).then((res) => {
        window.open(res);
      });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
